export function convertToHexadecimal(alpha) {
    const y = Math.floor(alpha * 255);
    const hexString = y.toString(16);
    return y < 16 ? `0${hexString}` : hexString;
}
